(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ScannerDetector", [], factory);
	else if(typeof exports === 'object')
		exports["ScannerDetector"] = factory();
	else
		root["ScannerDetector"] = factory();
})(window, function() {
return 